export default class QcQuickNote {
    "companyId": number;
    "qcQuickNoteId": number;
    "groupName": string;
    "name": string;
    "note": string;
} 